import React from 'react';
import theme from './Loader.scss';

const Loader = ({ message = 'Aan het laden...', children }) => (
    <div className={theme.wrapper}>
        {/* <div>
            <i className="fa fa-spin fa-cog" />
        </div> */}
        <p>{message}</p>
        {children}
    </div>
);

export default Loader;



// WEBPACK FOOTER //
// ./src/components/Loader.js